import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import useInViewport from '@/hooks/useInViewport';
import BasicChartBlock from '@/pages/Markets/MarketsComponents/Chart/BasicChartBlock';
import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

type SpotChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
};
export const SpotChartBlock = ({ layout, templateChartSeries }: SpotChartBlockType) => {
  const [containerRef, isInViewport] = useInViewport();
  const { loading, error, chartSeries } = useChartSeries(
    templateChartSeries,
    false,
    false,
    isInViewport
  );

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='spot'
      containerRef={containerRef}
      error={error}
      layout={layout}
      loading={loading}
    />
  );
};
